import { useUrlTab } from "../../hooks/useUrlTab";
import { HorizontalTabs } from "./HorizontalTabs";
import { TabButton, TabsMap } from "./types";
import { ItemTypeOption } from "../common/ItemTypePicker";
import { ItemType } from "../../types";
import "./tab-layout.css";

export type TabLayoutProps = {
  tabs: TabsMap;
  isEditMode?: boolean;
  itemTypes?: ItemTypeOption[];
  itemTypesLoading?: boolean;
  onItemTypeSelect?: (itemType: ItemType, tabKey: string) => void;
};

export const TabLayout = ({
  tabs,
  isEditMode = false,
  itemTypes = [],
  itemTypesLoading = false,
  onItemTypeSelect,
}: TabLayoutProps) => {
  const validTabKeys = Object.keys(tabs);
  const defaultTab = validTabKeys[0] || "";

  const [activeTab, setActiveTab] = useUrlTab({
    validTabs: validTabKeys,
    defaultTab,
  });

  const tabButtons: TabButton[] = Object.entries(tabs).map(([key, tab]) => ({
    label: tab.label,
    key: key,
    icon: tab.icon,
    canAdd: tab.canAdd,
  }));

  return (
    <div className="tab-layout__container">
      <div className="tab-layout__tabs-header">
        <HorizontalTabs
          tabs={tabButtons}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          isEditMode={isEditMode}
          itemTypes={itemTypes}
          itemTypesLoading={itemTypesLoading}
          onItemTypeSelect={onItemTypeSelect}
        />
      </div>
      <div className="tab-layout__tabs-content">
        {tabs[activeTab] && tabs[activeTab].content}
      </div>
    </div>
  );
};
